/* unplugin-vue-components disabled */import script from "./H5ChannelNav.vue?vue&type=script&setup=true&lang=js"
export * from "./H5ChannelNav.vue?vue&type=script&setup=true&lang=js"

import "./H5ChannelNav.vue?vue&type=style&index=0&id=0cc771aa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc771aa"]])

export default __exports__